import { render, staticRenderFns } from "./PlanSettingsDashboards.vue?vue&type=template&id=d791e81a"
import script from "./PlanSettingsDashboards.vue?vue&type=script&lang=ts"
export * from "./PlanSettingsDashboards.vue?vue&type=script&lang=ts"
import style0 from "./PlanSettingsDashboards.vue?vue&type=style&index=0&id=d791e81a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports